























import Vue from 'vue'
import Utils from '@/helpers/Utils'
import SmallRowOfferEl from '@/components/elements/SmallRowOfferEl.vue'
import { StoreItem, StoreListElInterface, UserLocation } from '@/config/interfaces'

interface StoreElement extends StoreItem {
  distance: number
}

export default Vue.extend({
  name: 'StoreListEl',

  data: () => ({
    stores: [] as Array<StoreElement>
  }),

  mounted () {
    const defaultNumDisplay = 5
    const stores = this.$props.templateItemData.places
    const userLocation = this.$store.getters.getUserLocation as UserLocation | null
    if (userLocation !== null) {
      const data = []
      for (let i = 0; i < stores.length; i++) {
        const store = stores[i]
        data.push({
          ...store,
          distance: Utils.calculateDistance(
            userLocation.latitude,
            userLocation.longitude,
            Number(store.lat),
            Number(store.lon)
          )
        })
      }
      data.sort((a, b) => a.distance > b.distance ? 1 : -1)
      this.stores = data.slice(0, this.$props.templateItemData.displayCount || defaultNumDisplay)
    } else {
      this.stores = stores.slice(0, this.$props.templateItemData.displayCount || defaultNumDisplay)
    }
  },

  components: { SmallRowOfferEl },

  props: {
    templateItemData: {
      type: Object as () => StoreListElInterface,
      required: true
    }
  }
})
